export default __webpack_public_path__ + "static/media/vacunaterd.d8b8f838.svg";